'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import ProductDetailController from './product-detail.controller';
import ProductService from './product.service';
import productCard from '../../../components/product-card';
import { Meta, Title } from '@angular/platform-browser';
import { downgradeInjectable } from '@angular/upgrade/static';
export default angular.module('eeComUiApp.productDetail', [ngMaterial, productCard])
    .factory('metaService', downgradeInjectable(Meta))
    .factory('titleService', downgradeInjectable(Title))
    .controller('ProductDetailController', ProductDetailController)
    .service('ProductService', ProductService)
    .filter('percentage', ['$filter', function ($filter) {
        return function (input, decimals) {
            return $filter('number')(input * 100, decimals) + '%';
        };
    }])
    .name;
//# sourceMappingURL=index.js.map